<div class="rss-properties-panel">
    <small class="debug">{{ me }}</small>
    @if (dynamicsInitialized) {
        <div class="settings-section">
            <!-- Display Mode Toggle Tabs -->
            <div class="properties-section display-mode-section">
                <mat-button-toggle-group (change)="onDisplayModeChange($event)"
                                         aria-label="Display mode toggle"
                                         class="display-mode-toggle"
                                         [value]="m_selectedDisplayMode">
                    <mat-button-toggle [value]="0">
                        <mat-icon>auto_awesome</mat-icon>
                        <span>ai feed</span>
                    </mat-button-toggle>
                    <mat-button-toggle [value]="1">
                        <mat-icon>newspaper</mat-icon>
                        <span>news feed</span>
                    </mat-button-toggle>
                </mat-button-toggle-group>
            </div>

            <!-- RSS Properties Section - Feed Type Selector Only (Show only in News Feed tab) -->
            @if (m_selectedDisplayMode === 1) {
                <div class="properties-section">
                    <div class="section-header">
                        <mat-icon class="section-icon">rss_feed</mat-icon>
                        <span class="section-title">choose from existing RSS feeds</span>
                    </div>

                    <div class="section-content">
                        <dynamic-form #feedForm [fields]="feedConfigInit" (submit)="submit($event)">
                        </dynamic-form>
                    </div>
                </div>
            }

            <!-- RSS Feed Details Section - Shows when RSS feed is selected AND News Feed tab is active -->
            @if (isRssFeedMode() && m_selectedDisplayMode === 1) {
                <div class="properties-section">
                    <div class="section-header">
                        <mat-icon class="section-icon">link</mat-icon>
                        <span class="section-title">rss feed details</span>
                    </div>

                    <div class="section-content">
                        <dynamic-form #rssFeedDetailsForm [fields]="rssFeedDetailsInit" (submit)="submit($event)">
                        </dynamic-form>
                    </div>
                </div>
            }

            <!-- AI Feed Configuration Section - Shows in AI Feed tab -->
            @if (m_selectedDisplayMode === 0) {
                <div class="properties-section">
                    <div class="section-header">
                        <mat-icon class="section-icon">auto_awesome</mat-icon>
                        <span class="section-title">create any custom AI data & news feed</span>
                    </div>

                    <div class="section-content">
                        <!-- Custom Feed Generator Button -->
                        <div class="custom-feed-button-container">
                            <button mat-raised-button color="accent" (click)="openAiFeedDialog()" class="custom-feed-button">
                                <mat-icon style="position: relative; left: -5px; top: 3px">auto_awesome</mat-icon>
                                {{ 'ai.customFeed' | transloco }}
                            </button>
                        </div>

                        <dynamic-form #aiFeedForm [fields]="aiFeedConfigInit" (submit)="submit($event)">
                        </dynamic-form>
                    </div>
                </div>
            }

            <!-- Embedded RSS Data Section - Shows right after feed type when Embedded is selected AND News Feed tab is active -->
            @if (isEmbeddedMode() && m_selectedDisplayMode === 1) {
                <div class="properties-section table-list-section">
                    <div class="section-header">
                        <mat-icon class="section-icon">data_object</mat-icon>
                        <span class="section-title">{{ 'general.embeddedRSS' | transloco }}</span>
                    </div>

                    <div class="section-content table-list-content">
                        <form [formGroup]="group" floatLabel="never">
                            <app-table-list-input matInput required
                                                (update)="onTableUpdate($event)"
                                                [callBackValue]="onCallBackValue()"
                                                [keepTableIds]="false"
                                                [cloneVals]="true"
                                                [confirmRemove]="false"
                                                [disableDrag]="false"
                                                [tableColumns]="tableColumns"
                                                [inputEditFormat]="{title: 'text', description: 'text'}"
                                                [inputEditRenamePath]="[{path: '$.title', key: 'title'}, {path: '$.description', key: 'description'}]"
                                                [tableClassName]="'rssEmbeddedTableControl'"
                                                [multiSelect]="false"
                                                [rememberSelection]="false"
                                                [allowFilter]="false"
                                                [buttons]="tableButtons"
                                                [expandableEditor]="true"
                                                [formControlName]="'rssEmbeddedTableControl'">
                            </app-table-list-input>
                        </form>
                    </div>
                </div>
            }

            <!-- UI Settings Section - Display & Animation Controls -->
            <div class="properties-section">
                <div class="section-header">
                    <mat-icon class="section-icon">tune</mat-icon>
                    <span class="section-title">ui settings</span>
                </div>

                <div class="section-content">
                    <dynamic-form [fields]="uiConfigInit" (submit)="submit($event)">
                    </dynamic-form>
                </div>
            </div>

            <!-- Title Font Settings Section -->
            <div class="properties-section">
                <div class="section-header">
                    <mat-icon class="section-icon">title</mat-icon>
                    <span class="section-title">{{ 'general.embeddedTitle' | transloco }}</span>
                </div>

                <div class="section-content">
                    <div *ngIf="showDescriptionFontSelector">
                        <app-font-selector (onChange)="onFontChanged($event, 'Title', 'Rss')" [hideVerticalAlignment]="false"
                                           [setConfig]="{i_config: sceneItem, pickArray: 0}"></app-font-selector>
                    </div>
                    <div *ngIf="!showDescriptionFontSelector">
                        <app-font-selector (onChange)="onFontChanged($event, 'Title', 'Rss')" [showOnlyVertical]="true"
                                           [setConfig]="{i_config: sceneItem, pickArray: 0}"></app-font-selector>
                    </div>
                </div>
            </div>

            <!-- Description Font Settings Section -->
            <div class="properties-section">
                <div class="section-header">
                    <mat-icon class="section-icon">description</mat-icon>
                    <span class="section-title">{{ 'general.embeddedDetails' | transloco }}</span>
                </div>

                <div class="section-content">
                    @if (showDescriptionFontSelector) {
                        <app-font-selector (onChange)="onFontChanged($event, 'Description', 'Rss')" [hideVerticalAlignment]="true"
                                           [setConfig]="{i_config: sceneItem, pickArray: 1}"></app-font-selector>
                    }
                </div>
            </div>
        </div>
    }
</div>
